import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import Textfield from "../Textfield";
import { ValidationGuest } from "../../helper";

const CheckoutPopup = ({ onClose, onSubmit, cartId }) => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState({
    name: "",
    email: "",
  });
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    let user = { name: name, email: email };
    const isValid = ValidationGuest(user, setError);
    if (isValid) {
      onSubmit(user);
    }
  };

  return (
    <CheckoutStyled onClick={onClose}>
      <CheckoutModal
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <InnerDiv>
          <CloseButton
            onClick={onClose}
            src={require("../../assets/images/cross.png")}
            alt="close"
          />
          <Logo src={require("../../assets/images/logo.png")} alt="logo" />
          <HeaderRight>{Text.checkoutPopupHeader}</HeaderRight>
          <SubHeaderRight>{Text.checkoutPopupSubHeader}</SubHeaderRight>

          <CheckoutForm>
            <>
              <Textfield
                placeholder={Text.signUpName}
                variant="Name"
                value={name}
                size="large"
                isRounded={true}
                error={!!error.name}
                onChange={(e) => {
                  setError((prevState) => {
                    return { ...prevState, name: "" };
                  });
                  setName(e.target.value);
                }}
                type="text"
                color={Colors.secondaryBlack}
                placeholderColor={Colors.santasGray}
              />

              {error.name && <ErrorMessage>{error.name}</ErrorMessage>}
            </>
            <TextFieldSpace>
              <Textfield
                placeholder={Text.loginEmailPlaceholder}
                variant="Email id"
                value={email}
                size="large"
                isRounded={true}
                error={!!error.email}
                onChange={(e) => {
                  setError((prevState) => {
                    return { ...prevState, email: "" };
                  });
                  setEmail(e.target.value);
                }}
                type="text"
                color={Colors.secondaryBlack}
                placeholderColor={Colors.santasGray}
              />
              {error.email && <ErrorMessage>{error.email}</ErrorMessage>}
            </TextFieldSpace>
            <AddSpace>
              <Button
                label="Continue as Guest"
                variant="outlined"
                outlineColor={Colors.aqua}
                size="large"
                onClick={handleSubmit}
              />
            </AddSpace>
            <Button
              label="Sign up"
              variant="filled"
              color={Colors.aqua}
              size="large"
              onClick={(e) => {
                navigate("/auth/signup");
                localStorage.setItem("cartId", cartId);
              }}
            />
          </CheckoutForm>
        </InnerDiv>
        <BottomContainer>
          <BottomFlex>
            <HeaderRight>{Text.returningCustomerHeader}</HeaderRight>
            <SubHeaderRight>{Text.returningCustomerSubHeader}</SubHeaderRight>
            <AddSpace>
              <Button
                label="Sign in"
                variant="filled"
                color={Colors.aqua}
                size="large"
                onClick={(e) => {
                  navigate("/auth/login");
                  localStorage.setItem("cartId", cartId);
                }}
              />
            </AddSpace>
          </BottomFlex>
        </BottomContainer>
      </CheckoutModal>
    </CheckoutStyled>
  );
};

export default CheckoutPopup;

const CheckoutStyled = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${Colors.blackOpacity};
  position: absolute;
  z-index: 99;
  top: 0;
  @media only screen and (max-width: 768px) {
    height: 100%;
  }
  @media only screen and (max-height: 790px) {
    height: 100%;
  }
`;
const CheckoutModal = styled.div`
  width: 31.7rem;
  border-radius: 0.5rem;

  background: ${Colors.blackOpacity};
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 120;
  @media only screen and (max-width: 768px) {
    height: fit-content;
    box-sizing: border-box;
    width: 100vw;
    height: fit-content;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media only screen and (min-height: 760px) {
      height: fit-content;
      box-sizing: border-box;
      width: 100vw;
      height: 100vh;
      border-radius: 0;
      display: flex;
      justify-content: center;
    }
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-grow: 1;
  // background: red;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 768px) {
    justify-content: center;
  }
`;
const CloseButton = styled.img`
  width: 26px;
  height: 25px;
  align-self: flex-end;
  margin-top: 1.5rem;
  margin-right: 1.5rem;
`;

const Logo = styled.img`
  width: 22rem;
  resize: contain;
  margin: 2rem 0;
  @media only screen and (max-width: 768px) {
    margin: 2rem 0;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 1.5rem;
  color: ${Colors.blackSqueeze};
  margin-top: 1.2rem;
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.mischkaApprox};
  margin-bottom: 2rem;
`;
const CheckoutForm = styled.form`
  width: 20rem;
  display: flex;
  flex-direction: column;
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  margin-top: 0.25rem;
`;

const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Poppins";
  font-size: 0.875rem;
  margin-top: 1rem;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const BottomFlex = styled.div`
  width: 20rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const AddSpace = styled.span`
  margin-top: 3rem;
  margin-bottom: 1rem;
`;

const TextFieldSpace = styled.span`
  margin-top: 1rem;
`;
